import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'; 
import hed from '../../img/intelli X Logo.png';
import Log1 from '../../img/lo1.png';
import Log2 from '../../img/lo2.png';
import Log3 from '../../img/lo3.png';
import './Header.css';
import Model from '../Model/Model';

const Header = () => { 

  let Location = useLocation();
  console.log(Location);

  return (
    <>
     
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top  ">
  <div className="container ">
    <NavLink className="navbar-brand" to="/"> 
    <img src={hed} alt='#' style={{width:'150px', height:'auto'}} /> 
    </NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav m-auto mb-2 mb-lg-0">

      

        <NavLink to="/Product"   style={{textDecoration:'none'}}>
        <li class="nav-item dropdown active  ">
          <span class="nav-link dropdown-toggle" to="/Product" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{color:Location.pathname=="/Product"?"#177FFC":"", borderBottom:Location.pathname=="/Product"?"1px solid #177FFC":""}}>
          Products
          </span>  
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">

          <NavLink to="/Product"  style={{textDecoration:'none'}}>   
          <li><span class="dropdown-item mt-2 " style={{margin:"0%"}} >
           <img src={Log2} alt='#'  className='pe-1'/>Genius Strix</span></li>
          </NavLink>

            <NavLink to="/cogniCampuX " style={{textDecoration:'none'}}>
            <li><span class="dropdown-item  mt-2"  style={{margin:"0%"}}>
             <img src={Log3} alt='#'  className='pe-1'/>  cogni campuX</span></li> 
            </NavLink>


             <NavLink to="/Hms" style={{textDecoration:'none'}}>
            <li><span class="dropdown-item mt-2 " style={{margin:'0%',
            color:Location.pathname=="/Hms"?"#177FFC":"", borderBottom:Location.pathname=="/Pricing"?"1px solid #177FFC":""}}>
              <img src={Log1} alt='#' className='pe-1'/>HMS Hostello</span></li>
            </NavLink>
          </ul>
        </li>
        </NavLink>


        <NavLink to="/Pricing" style={{textDecoration:'none'}}>
        <li className="nav-item">
          <span className="nav-link" style={{color:Location.pathname=="/Pricing"?"#177FFC":"", borderBottom:Location.pathname=="/Pricing"?"1px solid #177FFC":""}}>  Pricing</span>
        </li>
        </NavLink>

        <NavLink to="/Help" style={{textDecoration:'none'}}>
        <li className="nav-item">
          <span className="nav-link" style={{color:Location.pathname=="/Help"?"#177FFC":"", borderBottom:Location.pathname=="/Help"?"1px solid #177FFC":""}} >Help & Support</span>
        </li>
        </NavLink>

        <NavLink to="/Talk"  style={{textDecoration:'none'}}>
        <li className="nav-item">           
          <span className="nav-link" to="#" style={{color:Location.pathname=="/Talk"?"#177FFC":"", borderBottom:Location.pathname=="/Talk"?"1px solid #177FFC":""}}>Talk to Sales</span>
        </li>
        </NavLink> 
        
      </ul>
      <span className="d-flex">
        <button className="btn me-2" type="submit" data-bs-toggle="modal" data-bs-target="#exampleModal"  style={{backgroundColor:'#020202', color:'#fff',padding:'8px 40px',}}>Get Started</button> 
       
       {/* <NavLink to='/Login'>
        <button className="btn  " type="submit"  style={{backgroundColor:'transparent', color:'#000', border:'1px solid #000', padding:'8px 40px', }}>  Login</button>
           </NavLink>*/}
      </span>
    </div>
  </div>
</nav>
    
      



<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  style={{backdropFilter:'blur(5px)'}}>
<div class="modal-dialog modal-dialog-centered modal-lg" >
  <div class="modal-content"  style={{paddingTop:'0%'}}>
     

  <div class="modal-body">

        <Model/>
  </div>
    
  </div>
</div>
</div>
    </>
  )
}

export default Header
